<template>
  <div class="citysApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="hcity">
      <div class="left">
        <span>当前选择</span>
        <font>{{cityData.cityName}}</font>
      </div>
      <div class="right">
        <input type="text" v-model="txt" placeholder="按城市名称搜索" @input="search">
        <i class="el-icon-search"></i>
      </div>
    </div>
    <div style="height:55px"></div>

    <div v-if="txt === ''">
      <div v-for="(item,i) in setCitys">
        <h2>{{i}}</h2>
        <ul>
          <li v-for="(vo,k) in item" @click="chooseCitys(vo.cityCode,vo.cityName)">{{vo.cityName}}</li>
        </ul>
      </div>
    </div>
    <div v-if="txt != ''">
      <div v-for="(vo,i) in searchArr" style="margin-top:15px">
        <ul>
          <li @click="chooseCitys(vo.cityCode,vo.cityName)">{{vo.cityName}}</li>
        </ul>
      </div>
    </div>
  </div>
  
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        setCitys:[],
        cityData:[],
        arr:[],
        searchArr:[],
        isComposing:false,
        txt:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/citys');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }

    },
    mounted() {
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        var cCode = JSON.parse(localStorage.getItem('cCode'));
        if(cCode != null){
          this.cityData = cCode;
        }else{
          this.$router.push('index');
        }
        this.getCitys()
      }
      this.beforeMount();

      
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      search:function(event){
        if(this.txt === '') return;
        var value = this.txt;
        var res = this.arr.filter(function(item){
          return item.cityName.indexOf(value) > -1
        })
        this.searchArr = res;
      },
      chooseCitys:function(cityCode,cityName){
        var expires = Date.parse(new Date()) / 1000;
            expires = (expires + 1800) * 1000;
        var res = JSON.parse(localStorage.getItem('cCode'));
        var data = {
          cityCode:cityCode,
          cityName:cityName,
          expires:expires,
          latitude:res.latitude,
          longitude:res.longitude,
          key:1
        };
        localStorage.setItem('cCode', JSON.stringify(data));
        this.$router.go(-1);
      },
      getCitys:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/cities',
          dataType:'json',
          success:function(data){
            that.setCitys = data.data;
            var arr = [];
            for(var i in that.setCitys){
              for(var k in that.setCitys[i]){
                arr.push(that.setCitys[i][k])
              }
            }
            that.arr = arr;
            that.fullscreenLoading = false;
          }
        })
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .citysApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .citysApp .hcity{
    position:fixed;
    width:100%;
    height:55px;
    background:#ececec;
  }
  .citysApp .hcity .left{
    float:left;
    height:55px;
    width:33%;
    margin-left:3%;
    position: relative;
  }
  .citysApp .hcity .left span{
    width:40px;
    float:left;
    font-size:15px;
    color:#000;
    line-height:18px;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }
  .citysApp .hcity .left span:after{
    position:absolute;
    content:'';
    width:3px;
    height:3px;
    background:#000;
    border-radius:10px;
    right:0
  }
  .citysApp .hcity .left font{
    width:calc(100% - 47px);
    float:left;
    font-size:15px;
    line-height:18px;
    margin-left:7px;
    color:#666;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }
  .citysApp .hcity .right{
    float:right;
    width:57%;
    height:55px;
    margin-right:3%;
    position: relative;
  }
  .citysApp .hcity .right input{
    height:40px;
    width:calc(100% - 40px);
    outline:none;
    border:none;
    border-radius:40px;
    margin-top:7.5px;
    padding:0 10px 0 30px;
    font-size:15px
  }
  .citysApp .hcity .right i{
    position:absolute;
    top:50%;
    transform: translateY(-50%);
    left:10px;
    color:#555;
    font-size:16px
  }

  .citysApp h2{
    margin:0 auto;
    font-size:18px;
    padding:10px 4%
  }
  .citysApp ul{
    background:#fff;
  }
  .citysApp ul li{
    width:92%;
    margin:0 auto;
    height:50px;
    line-height:50px;
  }
  /*.citysApp font{
    display:inline-block;
    padding:8px 20px;
    background:#fff;
    border-radius:10px;
    font-size:15px;
    margin:15px 4%
  }*/
</style>